import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack } from '@mui/material';
import { BentoThemeProvider } from '@zenput/ui-bento';

interface DeleteFollowUpActionModalProps {
    description: string;
    handleCloseConfirmation: () => void;
    no: string;
    onSubmit: () => void;
    showConfirmation: boolean;
    title: string;
    yes: string;
}

export const DeleteFollowUpActionModal = (props: DeleteFollowUpActionModalProps) => {
    const { description, handleCloseConfirmation, no, onSubmit, showConfirmation, title, yes } = props;

    return (
        <BentoThemeProvider>
            <Dialog open={showConfirmation} onClose={handleCloseConfirmation}>
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ whiteSpace: 'pre-wrap' }}>{description}</DialogContentText>
                </DialogContent>

                <DialogActions
                    sx={{
                        justifyContent: 'center'
                    }}
                >
                    <Stack
                        sx={{
                            width: '100%'
                        }}
                        gap={2}
                    >
                        <Button variant="contained" color="error" onClick={onSubmit}>
                            {yes}
                        </Button>
                        <Button variant="text" onClick={handleCloseConfirmation}>
                            {no}
                        </Button>
                    </Stack>
                </DialogActions>
            </Dialog>
        </BentoThemeProvider>
    );
};
